import { useMemo } from 'react';

import { useCurrentWorkspacePropertiesAdapter } from '../../hooks/use-affine-adapter';
import { PagePropertiesManager } from './doc-properties-manager';

export const useDocPropertiesManager = (docId: string) => {
  // the workspace properties adapter adapter is reactive,
  // which means it's reference will change when any of the properties change
  // also it will trigger a re-render of the component
  const adapter = useCurrentWorkspacePropertiesAdapter();
  const manager = useMemo(() => {
    return new PagePropertiesManager(adapter, docId);
  }, [adapter, docId]);
  return manager;
};
